<div class="step-dialog-shell" [class.sequential-mode]="headerMode === 'sequential'" [class.tabs-mode]="headerMode === 'tabs'">
  @if (shouldRenderHeader) {
    <div class="dialog-header">
      <div class="header-left" [class.without-icon]="!shouldShowHeaderIcon">
        @if (shouldShowHeaderIcon) {
          <div class="icon-badge">
            <mat-icon>{{ headerIcon }}</mat-icon>
          </div>
        }
        @if (hasHeaderText) {
          <div class="header-text">
            @if (title) {
              <h2 class="title">{{ title }}</h2>
            }
            @if (subtitle) {
              <div class="subtitle">{{ subtitle }}</div>
            }
          </div>
        }
      </div>
      @if (showClose) {
        <button
          type="button"
          class="close-btn"
          mat-icon-button
          aria-label="Close dialog"
          (click)="onCloseClick()"
          [disabled]="disableClose"
          >
          <mat-icon>close</mat-icon>
        </button>
      }
    </div>
  }

  <!-- Header row -->
  @if (headerMode === 'sequential') {
    <div class="steps">
      @for (s of controller.steps; track s; let i = $index) {
        <button
          type="button"
          class="step"
          [class.active]="controller.stepIndex === i"
          [class.complete]="isStepComplete(i)"
          [class.locked]="isStepLocked(i)"
          (click)="onStepSelect(i)"
          [disabled]="isStepLocked(i)"
          >
          <div class="bubble">
            @if (isStepComplete(i)) {
              <mat-icon>check</mat-icon>
            } @else {
              {{ i + 1 }}
            }
          </div>
          <div class="label">{{ s.label }}</div>
          @if (i < controller.steps.length - 1) {
            <mat-icon class="chev">chevron_right</mat-icon>
          }
        </button>
      }
    </div>
  } @else {
    <div class="tab-steps" role="tablist" aria-label="Steps">
      @for (s of controller.steps; track s; let i = $index) {
        <button
          type="button"
          class="tab"
          role="tab"
          [attr.aria-selected]="controller.stepIndex === i"
          [class.active]="controller.stepIndex === i"
          [class.locked]="isStepLocked(i)"
          [disabled]="isStepLocked(i)"
          (click)="onStepSelect(i)"
          >
          @if (s.icon) {
            <mat-icon class="tab-icon">{{ s.icon }}</mat-icon>
          }
          <span class="tab-label">{{ s.label }}</span>
          @if (controller.getStepBadgeCount(s, i); as badgeCount) {
            <span class="tab-badge">{{ badgeCount }}</span>
          }
        </button>
      }
    </div>
  }


  @if (shouldRenderHeaderDivider) {
    <mat-divider class="header-divider"></mat-divider>
  }

  <!-- Body -->
  <div class="dialog-body">
    @if (currentStepTemplate) {
      <ng-container [ngTemplateOutlet]="currentStepTemplate"></ng-container>
    } @else {
      <div class="missing">No template provided for step {{ controller.stepIndex + 1 }}.</div>
    }

  </div>

  <mat-divider class="footer-divider"></mat-divider>

  <!-- Footer -->
  <div class="dialog-footer">
    @if (currentFooterTemplate) {
      <ng-container [ngTemplateOutlet]="currentFooterTemplate">
      </ng-container>
    } @else {
      <!-- Sequential default footer -->
      @if (headerMode === 'sequential') {
        <button mat-stroked-button class="shell-btn" (click)="controller.back()" [disabled]="controller.stepIndex === 0">
          <mat-icon class="btn-icon-left">chevron_left</mat-icon>
          Back
        </button>
        <button
          class="shell-btn shell-btn-primary"
          mat-raised-button
          color="primary"
          (click)="controller.next()"
          [disabled]="controller.stepIndex === controller.steps.length - 1"
          >
          Next
          <mat-icon class="btn-icon">chevron_right</mat-icon>
        </button>
      } @else {
        <div class="footer-left tabs-footer-left">
          <button mat-stroked-button class="shell-btn" (click)="controller.back()" [disabled]="controller.stepIndex === 0">
            <mat-icon class="btn-icon-left">chevron_left</mat-icon>
            {{ previousLabel }}
          </button>
          <button
            class="shell-btn"
            mat-stroked-button
            (click)="controller.next()"
            [disabled]="controller.stepIndex === controller.steps.length - 1"
            >
            {{ nextLabel }}
            <mat-icon class="btn-icon">chevron_right</mat-icon>
          </button>
        </div>
        <div class="footer-right tabs-footer-right">
          @if (showCancel) {
            <button mat-stroked-button class="shell-btn" (click)="onCancelClick()" [disabled]="disableCancel">
              {{ cancelLabel }}
            </button>
          }
          @if (showPrimary) {
            <button
              class="shell-btn shell-btn-primary"
              mat-raised-button
              color="primary"
              (click)="onPrimaryClick()"
              [disabled]="disablePrimary"
              >
              {{ primaryLabel }}
            </button>
          }
        </div>
      }
      <!-- Tabs default footer -->
    }

  </div>
</div>
